// eslint-disable-next-line import/prefer-default-export
export const customLoader = ({ src, width, quality }) => `${src}?w=${width}&q=${quality || 100}`;
